// Module
var code = "<div class=\"col-xs-12\"> <record-grid datasource=\"stateController.gridDataSource\" columns=\"stateController.columns\" grid-settings=\"stateController.gridSettings\" default-sort=\"'Location,SlotNumber'\" default-query=\"stateController.defaultQuery\"> </record-grid> </div> ";
// Exports
export default code;